<template>
  <div class="BB-timer-modal-manual-counter">
    <VueTimepicker
      v-model="timer"
      hideClearButton
      inputWidth="90px"
      format="HH:mm:ss"
      manual-input
      hide-dropdown
      aria-controls="none"
    />
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'

export default {
  name: 'BBTimerModalManualCounter',
  components: {
    VueTimepicker
  },
  props: {
    manualTimer: {
      type: String,
      default: '00:00:00'
    }
  },
  computed: {
    timer: {
      get () {
        return this.manualTimer
      },
      set (data) {
        this.$emit('update', data)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../sass/variables";

  .BB-timer-modal-manual-counter {

    .controls {
      display: none !important;
    }

    .vue__time-picker input.display-time {
      padding: 0;
      height: 0;
    }

    .time-picker input {
      padding: 6px 10px 6px 10px !important;
      height: 30px !important;
      border-radius: 5px;
      border: 1px solid $color-mercury;
      font-size: 14px !important;
      line-height: 17px;
      letter-spacing: 0.3px;
      color: $color-black;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TimerControl/BBTimerModal/BBTimerModalManual/BBTimerModalManualCounter.vue